import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "max-w-[1040px]" }
const _hoisted_2 = { class: "overflow-x-auto p-2 -m-2" }
const _hoisted_3 = { class: "flex justify-end" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "truncate" }
const _hoisted_6 = { class: "flex justify-end" }
const _hoisted_7 = {
  key: 0,
  class: "rounded-xl border border-gray-200 bg-white px-6 py-10 shadow-sm"
}
const _hoisted_8 = {
  key: 0,
  class: "col-span-12"
}
const _hoisted_9 = { class: "text-sm text-gray-700" }
const _hoisted_10 = {
  key: 0,
  class: "py-2 flex justify-between items-start"
}
const _hoisted_11 = { class: "flex justify-between items-center" }
const _hoisted_12 = { class: "flex justify-between items-center" }
const _hoisted_13 = { class: "flex justify-between items-center" }
const _hoisted_14 = {
  key: 1,
  class: "py-2 flex justify-between items-start"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]

import { ArrowDownOnSquareIcon, PencilIcon, XMarkIcon } from '@heroicons/vue/20/solid'
import { Bars3Icon, XCircleIcon } from '@heroicons/vue/24/outline'
import Sortable from 'sortablejs'
import { computed, onMounted, ref, watch } from 'vue'

import EmptyState from '@/components/neue/EmptyState'
import FormElement from '@/components/neue/FormElement'
import FormSection from '@/components/neue/FormSection'
import NeueButton from '@/components/neue/NeueButton'
import NeueLoading from '@/components/neue/NeueLoading'
import NeueTablist from '@/components/neue/NeueTablist'
import SettingsSection from '@/components/neue/SettingsSection.vue'
import TablistGrid from '@/components/neue/TablistGrid.vue'
import TablistHeader from '@/components/neue/TablistHeader'
import TablistRow from '@/components/neue/TablistRow'
import api from '@/store/api'
import { mapRelationship, mapRelationships } from '@/store/mappers'


export default {
  __name: 'StoreQuestions',
  props: ['id', 'when'],
  setup(__props) {

const loading = ref(true)
const modal = ref({ open: false })
const props = __props
const store = computed(() => mapRelationship({ type: 'store', id: props.id }))

const COPY = {
  before_selection: {
    title: 'Your questions',
    description:
      'Asked before customers choose products, such as "What day would you like to order for?" or "Is this a gift?" Drag to reorder - customers answer them in this order.'
  },
  before_checkout: {
    title: 'Your questions',
    description:
      'Asked at checkout, before customers pay, such as "Is this a gift?" or "What\'s your email?" Drag to reorder - customers answer them in this order.'
  },
  after_checkout: {
    title: 'Your questions',
    description:
      'Asked on the receipt once the order is paid, like "How did you hear about us?" Drag to reorder - customers answer them in this order.'
  }
}

const cols = [
  { width: 'minmax(180px, 2fr)' },
  { width: 'minmax(100px, 1fr)' },
  { width: 'minmax(150px, 1.4fr)' },
  { width: '120px' }
]

const copy = computed(() => COPY[props.when] ?? COPY.before_selection)

const rows = ref(null)

watch(rows, () => {
  if (rows.value)
    new Sortable(rows.value, {
      handle: '.cursor-move',
      ghostClass: 'bg-gray-200',
      dragClass: 'bg-white',
      onSort(e) {
        const list = questions.value
        const moved = list.splice(e.oldIndex, 1)[0]
        list.splice(e.newIndex, 0, moved)
        list.map((x, i) =>
          api.call('PUT', `stores/${props.id}/questions/${x.id}`, {
            question: {
              order: i
            }
          })
        )
      }
    })
})

onMounted(async () => {
  await api.call('GET', `stores/${props.id}?included=questions,questions.question_possible_answers`)
  loading.value = false
})

const questions = computed(() =>
  mapRelationships(store.value?.relationships.questions.data)
    .filter(x => x.attributes.belongs_to_setting === props.when)
    .filter(x => x.attributes.type !== 'GiftCardEmailQuestion' && x.attributes.type !== 'GiftCardMessageQuestion')
    .sort((a, b) => a.attributes.order - b.attributes.order)
)
const answers = question => mapRelationships(question.relationships.question_possible_answers.data)

const questionTypes = [
  { name: 'Full name question', value: 'NameQuestion' },
  { name: 'First and last name question', value: 'FirstAndLastNameQuestion' },
  { name: 'Email question', value: 'EmailQuestion' },
  { name: 'Order note question', value: 'BottleNoteQuestion' },
  { name: 'Variant preference question', value: 'VariantPreferenceQuestion' },
  { name: 'Dietary option preference question', value: 'DietaryPreferenceQuestion' },
  { name: 'Membership tier question', value: 'MembershipTierQuestion' },
  { name: 'Fulfillment slot question', value: 'FulfillmentSlotQuestion' },
  { name: 'Package question', value: 'PackageQuestion' },
  { name: 'Gift card email question', value: 'GiftCardEmailQuestion' },
  { name: 'Gift card message question', value: 'GiftCardMessageQuestion' },
  { name: 'Gift order question', value: 'GiftQuestion' }
]
const availableQuestionTypes = computed(() =>
  questionTypes.filter(x => x.value !== 'GiftQuestion' || props.when === 'before_checkout')
)
const mapQuestionType = type => questionTypes.find(x => x.value === type).name

const addQuestion = () => {
  modal.value = {
    open: true,
    mode: 'add',
    type: 'BottleNoteQuestion',
    format: 'textarea',
    question: '',
    key: '',
    secondary: '',
    placeholder: '',
    required: false,
    every: true
  }
}

const editQuestion = question => {
  modal.value = {
    open: true,
    mode: 'edit',
    id: question.id,
    type: question.attributes.type,
    question: question.attributes.question,
    key: question.attributes.key,
    secondary: question.attributes.secondary_info,
    placeholder: question.attributes.placeholder,
    required: question.attributes.required,
    every: question.attributes.ask_for_every_bottle,
    format: question.attributes.answer_format,
    answers: answers(question),
    editingAnswer: {}
  }
}

const saveModal = () => {
  let action, url
  if (modal.value.mode === 'add') {
    action = 'POST'
    url = `stores/${props.id}/questions`
  } else if (modal.value.mode === 'edit') {
    action = 'PUT'
    url = `stores/${props.id}/questions/${modal.value.id}`
  }

  api
    .call(action, url, {
      question: {
        answer_format: modal.value.type === 'BottleNoteQuestion' ? modal.value.format : undefined,
        ask_for_every_bottle: modal.value.every,
        belongs_to_setting: props.when,
        key: modal.value.key,
        placeholder: modal.value.placeholder,
        question: modal.value.question,
        required: modal.value.required,
        secondary_info: modal.value.secondary,
        store_id: props.id,
        type: modal.value.type
      }
    })
    .then(() => {
      modal.value.open = false
    })
}

const deleteQuestion = question => {
  if (!confirm(`Delete ${question.attributes.question}?`)) return
  api.call('DELETE', `stores/${props.id}/questions/${question.id}`, {}, { delete: false })
}

const addAnswer = () => {
  api
    .call('PUT', `stores/${props.id}/questions/${modal.value.id}`, {
      question: {
        question_possible_answers_attributes: [
          {
            title: '',
            description: '',
            map_to_value: ''
          }
        ]
      }
    })
    .then(response => {
      modal.value.answers = answers(response.data.data)
      const lastAnswer = answers(response.data.data).reduce((a, b) => (parseInt(a.id) > parseInt(b.id) ? a : b))
      editAnswer(lastAnswer)
    })
}

const editAnswer = answer => {
  modal.value.editingAnswer = {
    answer,
    title: answer.attributes.title,
    description: answer.attributes.description,
    value: answer.attributes.map_to_value
  }
}

const saveAnswer = () => {
  api
    .call('PUT', `stores/${props.id}/questions/${modal.value.id}`, {
      question: {
        question_possible_answers_attributes: {
          id: modal.value.editingAnswer.answer.id,
          title: modal.value.editingAnswer.title,
          description: modal.value.editingAnswer.description,
          map_to_value: modal.value.editingAnswer.value
        }
      }
    })
    .then(response => {
      modal.value.answers = answers(response.data.data)
    })
  modal.value.editingAnswer = {}
}

const deleteAnswer = answer => {
  api
    .call('PUT', `stores/${props.id}/questions/${answer.relationships.question.data.id}`, {
      question: {
        question_possible_answers_attributes: {
          id: answer.id,
          _destroy: true
        }
      }
    })
    .then(response => {
      modal.value.answers = answers(response.data.data)
    })
}

return (_ctx, _cache) => {
  const _component_InputField = _resolveComponent("InputField")
  const _component_InputArea = _resolveComponent("InputArea")
  const _component_NeueToggle = _resolveComponent("NeueToggle")
  const _component_SelectInput = _resolveComponent("SelectInput")
  const _component_TheModal = _resolveComponent("TheModal")
  const _directive_tippy = _resolveDirective("tippy")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(NeueLoading), { loading: loading.value }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(SettingsSection, {
            title: copy.value.title,
            description: copy.value.description,
            plain: ""
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(NeueTablist), null, {
                  head: _withCtx(() => [
                    _createVNode(_unref(TablistHeader), null, {
                      default: _withCtx(() => [
                        _createVNode(TablistGrid, {
                          columns: cols,
                          header: "",
                          class: "items-center"
                        }, {
                          default: _withCtx(() => [
                            _cache[15] || (_cache[15] = _createElementVNode("div", null, "Question", -1)),
                            _cache[16] || (_cache[16] = _createElementVNode("div", null, "Required", -1)),
                            _cache[17] || (_cache[17] = _createElementVNode("div", null, "Type", -1)),
                            _createElementVNode("div", _hoisted_3, [
                              _createVNode(_unref(NeueButton), {
                                type: "secondary",
                                onClick: addQuestion
                              }, {
                                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                  _createTextVNode("+ Question", -1)
                                ]))]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      ref_key: "rows",
                      ref: rows,
                      class: "divide-y divide-gray-200"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questions.value, (question) => {
                        return (_openBlock(), _createBlock(_unref(TablistRow), {
                          key: question.id,
                          class: "cursor-pointer",
                          onClick: $event => (editQuestion(question))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(TablistGrid, {
                              columns: cols,
                              class: "items-center"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_4, [
                                  _createElementVNode("div", {
                                    class: "cursor-move -ml-4 px-3 -mt-2 -mb-2 py-2",
                                    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                                  }, [
                                    _createVNode(_unref(Bars3Icon), { class: "h-5 w-5" })
                                  ]),
                                  _createElementVNode("span", _hoisted_5, _toDisplayString(question.attributes.question), 1)
                                ]),
                                _createElementVNode("div", null, _toDisplayString(question.attributes.required ? 'Required' : 'Not required'), 1),
                                _createElementVNode("div", null, _toDisplayString(mapQuestionType(question.attributes.type)), 1),
                                _createElementVNode("div", _hoisted_6, [
                                  _createVNode(_unref(XCircleIcon), {
                                    class: "h-6 w-6 hover:text-black shrink-0",
                                    onClick: _withModifiers($event => (deleteQuestion(question)), ["stop"])
                                  }, null, 8, ["onClick"])
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ], 512)
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, questions.value.length]
              ]),
              (!questions.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_unref(EmptyState), { plural: "questions" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NeueButton), {
                          type: "secondary",
                          onClick: addQuestion
                        }, {
                          default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                            _createTextVNode("+ Question", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["title", "description"])
        ])
      ]),
      _: 1
    }, 8, ["loading"]),
    _createVNode(_component_TheModal, {
      "is-open": modal.value.open,
      "modal-title": modal.value.mode === 'add' ? 'Add question' : 'Edit question',
      onCloseModal: _cache[13] || (_cache[13] = $event => (modal.value.open = false))
    }, {
      main: _withCtx(() => [
        _createVNode(_unref(FormSection), null, {
          default: _withCtx(() => [
            _createVNode(_unref(FormElement), null, {
              default: _withCtx(() => [
                _createVNode(_component_InputField, {
                  modelValue: modal.value.question,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((modal.value.question) = $event)),
                  name: "Question",
                  placeholder: "Your question"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(FormElement), null, {
              default: _withCtx(() => [
                _createVNode(_component_InputField, {
                  modelValue: modal.value.placeholder,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((modal.value.placeholder) = $event)),
                  name: "Placeholder",
                  placeholder: "The placeholder that goes in the input box"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (modal.value.type === 'VariantPreferenceQuestion')
              ? (_openBlock(), _createBlock(_unref(FormElement), { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputField, {
                      modelValue: modal.value.key,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((modal.value.key) = $event)),
                      name: "Key"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_unref(FormElement), null, {
              default: _withCtx(() => [
                _createVNode(_component_InputArea, {
                  modelValue: modal.value.secondary,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((modal.value.secondary) = $event)),
                  name: "Description"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(FormElement), null, {
              default: _withCtx(() => [
                _createVNode(_component_NeueToggle, {
                  modelValue: modal.value.required,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((modal.value.required) = $event)),
                  name: "Required"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (
            modal.value.type === 'BottleNoteQuestion' ||
            modal.value.type === 'VariantPreferenceQuestion' ||
            modal.value.type === 'MembershipTierQuestion' ||
            modal.value.type === 'FulfillmentSlotQuestion' ||
            modal.value.type === 'DietaryPreferenceQuestion' ||
            modal.value.type === 'PackageQuestion'
          )
              ? (_openBlock(), _createBlock(_unref(FormElement), { key: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_NeueToggle, {
                      modelValue: modal.value.every,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((modal.value.every) = $event)),
                      name: "Ask each time the customer orders"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_unref(FormElement), null, {
              default: _withCtx(() => [
                _createVNode(_component_SelectInput, {
                  modelValue: modal.value.type,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((modal.value.type) = $event)),
                  name: "Type",
                  options: availableQuestionTypes.value
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            }),
            (modal.value.type === 'BottleNoteQuestion')
              ? (_openBlock(), _createBlock(_unref(FormElement), { key: 2 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SelectInput, {
                      modelValue: modal.value.format,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((modal.value.format) = $event)),
                      name: "Answer format",
                      options: [
              { name: 'Text', value: 'textarea' },
              { name: 'Multiple selection', value: 'multiselect' },
              { name: 'Single selection', value: 'singleselect' }
            ]
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_unref(FormElement), null, {
              default: _withCtx(() => [
                (
              modal.value.mode === 'edit' &&
              (modal.value.type === 'VariantPreferenceQuestion' ||
                modal.value.format === 'multiselect' ||
                modal.value.format === 'singleselect')
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _cache[25] || (_cache[25] = _createElementVNode("label", {
                        for: "question-answers",
                        class: "block font-medium text-gray-700 mb-2"
                      }, "Possible answers", -1)),
                      _createElementVNode("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modal.value.answers, (answer) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: answer.id
                          }, [
                            (answer === modal.value.editingAnswer.answer)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_11, [
                                      _cache[19] || (_cache[19] = _createElementVNode("span", { class: "font-medium mr-2" }, "Title:", -1)),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((modal.value.editingAnswer.title) = $event)),
                                        type: "text",
                                        class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      }, null, 512), [
                                        [_vModelText, modal.value.editingAnswer.title]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_12, [
                                      _cache[20] || (_cache[20] = _createElementVNode("span", { class: "font-medium mr-2" }, "Description:", -1)),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((modal.value.editingAnswer.description) = $event)),
                                        type: "text",
                                        class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      }, null, 512), [
                                        [_vModelText, modal.value.editingAnswer.description]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_13, [
                                      _cache[21] || (_cache[21] = _createElementVNode("span", { class: "font-medium mr-2 whitespace-nowrap" }, "Answer value:", -1)),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => ((modal.value.editingAnswer.value) = $event)),
                                        type: "text",
                                        class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      }, null, 512), [
                                        [_vModelText, modal.value.editingAnswer.value]
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", null, [
                                    _withDirectives((_openBlock(), _createElementBlock("button", {
                                      class: "inline-flex items-center shadow-sm p-1.5 border border-gray-300 text-sm leading-5 font-medium rounded-full bg-white hover:border-blue-600 transition-all duration-150 text-gray-500 hover:text-blue-600",
                                      onClick: _withModifiers(saveAnswer, ["prevent"])
                                    }, [
                                      _createVNode(_unref(ArrowDownOnSquareIcon), {
                                        class: "h-4 w-4",
                                        "aria-hidden": "true"
                                      })
                                    ])), [
                                      [_directive_tippy, { content: 'Save' }]
                                    ])
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", null, [
                                      _cache[22] || (_cache[22] = _createElementVNode("span", { class: "font-medium" }, "Title:", -1)),
                                      _createTextVNode(" " + _toDisplayString(answer.attributes.title), 1)
                                    ]),
                                    _createElementVNode("div", null, [
                                      _cache[23] || (_cache[23] = _createElementVNode("span", { class: "font-medium" }, "Description:", -1)),
                                      _createTextVNode(" " + _toDisplayString(answer.attributes.description), 1)
                                    ]),
                                    _createElementVNode("div", null, [
                                      _cache[24] || (_cache[24] = _createElementVNode("span", { class: "font-medium" }, "Answer value:", -1)),
                                      _createTextVNode(" " + _toDisplayString(answer.attributes.map_to_value), 1)
                                    ])
                                  ]),
                                  _createElementVNode("div", null, [
                                    _withDirectives((_openBlock(), _createElementBlock("button", {
                                      class: "inline-flex items-center shadow-sm p-1.5 border border-gray-300 text-sm leading-5 font-medium rounded-full bg-white hover:border-blue-600 transition-all duration-150 text-gray-500 hover:text-blue-600",
                                      onClick: _withModifiers($event => (editAnswer(answer)), ["prevent"])
                                    }, [
                                      _createVNode(_unref(PencilIcon), {
                                        class: "h-4 w-4",
                                        "aria-hidden": "true"
                                      })
                                    ], 8, _hoisted_15)), [
                                      [_directive_tippy, { content: 'Edit' }]
                                    ]),
                                    _withDirectives((_openBlock(), _createElementBlock("button", {
                                      class: "ml-1 inline-flex items-center shadow-sm p-1.5 border border-gray-300 text-sm leading-5 font-medium rounded-full bg-white hover:border-blue-600 transition-all duration-150 text-gray-500 hover:text-blue-600",
                                      onClick: _withModifiers($event => (deleteAnswer(answer)), ["prevent"])
                                    }, [
                                      _createVNode(_unref(XMarkIcon), {
                                        class: "h-4 w-4",
                                        "aria-hidden": "true"
                                      })
                                    ], 8, _hoisted_16)), [
                                      [_directive_tippy, { content: 'Delete' }]
                                    ])
                                  ])
                                ]))
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("button", {
                        class: "btn-primary",
                        onClick: _withModifiers(addAnswer, ["prevent"])
                      }, "+ Answer")
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(NeueButton), {
          type: "secondary",
          onClick: _cache[12] || (_cache[12] = $event => (modal.value.open = false))
        }, {
          default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
            _createTextVNode("Cancel", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_unref(NeueButton), {
          type: "primary",
          onClick: saveModal
        }, {
          default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
            _createTextVNode("Save", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["is-open", "modal-title"])
  ], 64))
}
}

}